var toValString = require('./toString')
var keys = require('../base/keys')

function helperFormatEscaper (dataMap) {
  var replaceRegexp = new RegExp('(?:' + keys(dataMap).join('|') + ')', 'g')
  return function (str) {
    return toValString(str).replace(replaceRegexp, function (match) {
      return dataMap[match]
    })
  }
}

module.exports = helperFormatEscaper



//////////////////
// WEBPACK FOOTER
// ./node_modules/xe-utils/methods/string/helperFormatEscaper.js
// module id = plNV
// module chunks = 94